export const LIST_FORM_IDXPATH = 'my:ID';
